/** Shared helpers for Aseprite atlases loaded via Phaser `load.atlas`. */

export function frameIndex(name: string) {
  const match = name.match(/(\d+)\.png$/i);
  return match ? parseInt(match[1], 10) : 0;
}

export function sortedAtlasFrames(scene: Phaser.Scene, textureKey: string) {
  if (!scene.textures.exists(textureKey)) return [];
  return scene.textures
    .get(textureKey)
    .getFrameNames()
    .filter((name) => name !== '__BASE' && /\.png$/i.test(name))
    .sort((a, b) => frameIndex(a) - frameIndex(b));
}

export function ensureAnimFromAtlas(
  scene: Phaser.Scene,
  animKey: string,
  textureKey: string,
  frameRate = 30,
  repeat = -1,
) {
  if (scene.anims.exists(animKey)) return;
  const names = sortedAtlasFrames(scene, textureKey);
  if (!names.length) return;
  scene.anims.create({
    key: animKey,
    frames: names.map((frame) => ({ key: textureKey, frame })),
    frameRate,
    repeat,
  });
}
